"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Metaform REST API
 * REST API for Metaform
 *
 * The version of the OpenAPI document: 2.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const runtime_1 = require("../runtime");
function MetaformFieldOptionFromJSON(json) {
    return MetaformFieldOptionFromJSONTyped(json, false);
}
exports.MetaformFieldOptionFromJSON = MetaformFieldOptionFromJSON;
function MetaformFieldOptionFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': json['name'],
        'text': json['text'],
        'checked': !runtime_1.exists(json, 'checked') ? undefined : json['checked'],
        'selected': !runtime_1.exists(json, 'selected') ? undefined : json['selected'],
    };
}
exports.MetaformFieldOptionFromJSONTyped = MetaformFieldOptionFromJSONTyped;
function MetaformFieldOptionToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'text': value.text,
        'checked': value.checked,
        'selected': value.selected,
    };
}
exports.MetaformFieldOptionToJSON = MetaformFieldOptionToJSON;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTWV0YWZvcm1GaWVsZE9wdGlvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9nZW5lcmF0ZWQvY2xpZW50L21vZGVscy9NZXRhZm9ybUZpZWxkT3B0aW9uLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQSxvQkFBb0I7QUFDcEIsb0JBQW9CO0FBQ3BCOzs7Ozs7Ozs7O0dBVUc7O0FBRUgsd0NBQStDO0FBaUMvQyxTQUFnQiwyQkFBMkIsQ0FBQyxJQUFTO0lBQ2pELE9BQU8sZ0NBQWdDLENBQUMsSUFBSSxFQUFFLEtBQUssQ0FBQyxDQUFDO0FBQ3pELENBQUM7QUFGRCxrRUFFQztBQUVELFNBQWdCLGdDQUFnQyxDQUFDLElBQVMsRUFBRSxtQkFBNEI7SUFDcEYsSUFBSSxDQUFDLElBQUksS0FBSyxTQUFTLENBQUMsSUFBSSxDQUFDLElBQUksS0FBSyxJQUFJLENBQUMsRUFBRTtRQUN6QyxPQUFPLElBQUksQ0FBQztLQUNmO0lBQ0QsT0FBTztRQUVILE1BQU0sRUFBRSxJQUFJLENBQUMsTUFBTSxDQUFDO1FBQ3BCLE1BQU0sRUFBRSxJQUFJLENBQUMsTUFBTSxDQUFDO1FBQ3BCLFNBQVMsRUFBRSxDQUFDLGdCQUFNLENBQUMsSUFBSSxFQUFFLFNBQVMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxTQUFTLENBQUMsQ0FBQyxDQUFDLElBQUksQ0FBQyxTQUFTLENBQUM7UUFDakUsVUFBVSxFQUFFLENBQUMsZ0JBQU0sQ0FBQyxJQUFJLEVBQUUsVUFBVSxDQUFDLENBQUMsQ0FBQyxDQUFDLFNBQVMsQ0FBQyxDQUFDLENBQUMsSUFBSSxDQUFDLFVBQVUsQ0FBQztLQUN2RSxDQUFDO0FBQ04sQ0FBQztBQVhELDRFQVdDO0FBRUQsU0FBZ0IseUJBQXlCLENBQUMsS0FBa0M7SUFDeEUsSUFBSSxLQUFLLEtBQUssU0FBUyxFQUFFO1FBQ3JCLE9BQU8sU0FBUyxDQUFDO0tBQ3BCO0lBQ0QsSUFBSSxLQUFLLEtBQUssSUFBSSxFQUFFO1FBQ2hCLE9BQU8sSUFBSSxDQUFDO0tBQ2Y7SUFDRCxPQUFPO1FBRUgsTUFBTSxFQUFFLEtBQUssQ0FBQyxJQUFJO1FBQ2xCLE1BQU0sRUFBRSxLQUFLLENBQUMsSUFBSTtRQUNsQixTQUFTLEVBQUUsS0FBSyxDQUFDLE9BQU87UUFDeEIsVUFBVSxFQUFFLEtBQUssQ0FBQyxRQUFRO0tBQzdCLENBQUM7QUFDTixDQUFDO0FBZEQsOERBY0MifQ==